import { useEffect, useMemo, useState } from "react";
import type { CallRing, Uuid } from "@shared/api";

/** Вызовы, у которых не вышел срок. */
export function liveRings(rings: CallRing[] | undefined, now: number): CallRing[] {
  return (rings ?? []).filter((ring) => Date.parse(ring.until) > now);
}

/**
 * Часы вызовов: «сейчас», которое само переводится к ближайшему сроку. Вызов
 * гаснет без события — о вышедшем сроке сервер не рассылает, его знает каждый.
 */
export function useRingClock(rings: Record<Uuid, CallRing[]>): number {
  const [now, setNow] = useState(() => Date.now());

  // Пришёл новый вызов — часы сверяются заново: прежнее «сейчас» могло застыть.
  useEffect(() => setNow(Date.now()), [rings]);

  const next = useMemo(() => {
    let soonest = Infinity;
    for (const list of Object.values(rings)) {
      for (const ring of list) {
        const at = Date.parse(ring.until);
        if (at > now && at < soonest) soonest = at;
      }
    }
    return soonest;
  }, [rings, now]);

  useEffect(() => {
    if (next === Infinity) return;
    const timer = window.setTimeout(() => setNow(Date.now()), Math.max(0, next - Date.now()) + 50);
    return () => window.clearTimeout(timer);
  }, [next]);

  return now;
}
